export default __webpack_public_path__ + "static/media/git and github.9f0929d9.png";